<template>
  <div style="background-color:#F7F7F7;padding-bottom:70px;" id="outermost">

    <van-nav-bar
      title="修改企业"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />
    <van-form @submit="onSubmit">
      <div class="topDiv">
        <van-cell-group>
          <van-field label="企业名称" required v-model="companyInfo.companyName" input-align="right" placeholder="点击输入企业名称"
                     :rules="[{ required: true, message: '请输入企业名称'}]"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="行业" required readonly v-model="companyInfo.industryName" input-align="right"
                     placeholder="点击选择行业"
                     :rules="[{ required: true, message: '请输入行业'}]" @click="showIndustryPicker = true"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="第二行业" readonly v-model="companyInfo.industry2Name" @click="showIndustry2Picker = true"
                     input-align="right" placeholder="点击选择第二行业"/>
        </van-cell-group>
      </div>
      <div class="topDiv">
        <van-cell-group>
          <van-field label="联系人1" required v-model="companyInfo.contacts1" maxlength="50" input-align="right"
                     placeholder="点击输入联系人1"
                     :rules="[{ required: true, message: '请输入联系人1'}]"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="联系电话" required v-model="companyInfo.phone1" maxlength="11" input-align="right"
                     placeholder="点击输入联系电话"
                     :rules="[{ required: true, message: '请输入联系电话'}]"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="联系人2" v-model="companyInfo.contacts2" maxlength="50" input-align="right"
                     placeholder="点击输入联系人2"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="联系电话" v-model="companyInfo.phone2" maxlength="11" input-align="right"
                     placeholder="点击输入联系电话"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="联系人3" v-model="companyInfo.contacts3" input-align="right" placeholder="点击输入联系人3"/>
        </van-cell-group>
        <van-cell-group>
          <van-field label="联系电话" v-model="companyInfo.phone3" input-align="right" placeholder="点击输入联系电话"/>
        </van-cell-group>
      </div>
      <div class="topDiv">
        <van-cell-group>
          <van-field label="企业地址" type="textarea" maxlength="100" show-word-limit v-model="companyInfo.companyAddress"
                     input-align="right" placeholder="点击输入企业地址"/>
        </van-cell-group>
      </div>
      <div class='topDiv'>
        <van-cell-group>
          <van-field name="radio" label-width="80" label="企业生产状态" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.status" direction="horizontal">
                <van-radio name="1">运行</van-radio>
                <van-radio name="2">停产</van-radio>
                <van-radio name="3">迁出</van-radio>
                <van-radio name="4">其他</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="topDiv">
        <van-cell-group>
          <van-field name="radio" label-width="200" label="场地基本情况" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.areaSituation" direction="horizontal">
                <van-radio name="1">拿地</van-radio>
                <van-radio name="2">租赁</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="100" label="应急预案等级" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.emergencyPlanLevel" direction="horizontal">
                <van-radio name="1">重大</van-radio>
                <van-radio name="2">较大</van-radio>
                <van-radio name="3">一般</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="是否位于104工业园区" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.plot" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="是否为简易监管单位" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.basicManage" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="是否为一般监管单位" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.generalManage" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="是否为污染源子库单位" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.emissionTermbase" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="是否为重点监管单位" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.keyManage" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="废水是否安装在线监测设备" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.waterOnlineMonitor" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="废水是否涉重金属" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.waterHeavyMetal" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="废气是否安装在线监测设备" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.gasOnlineMonitor" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="废气是否涉重金属" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.gasHeavyMetal" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="是否属于强制性清洁生产" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.mandatoryCleanProduction" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="是否有非道路移动机械" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.nonRoadMobileMachinery" direction="horizontal">
                <van-radio name="0">否</van-radio>
                <van-radio name="1">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="环保手续" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.envRelation" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="排水许可" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.waterPermit" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="治理设施" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.facility" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="危险废物处理合同及备案" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.hazardousProcessAcquired" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="一般工业固废处理合同及备案" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.generalHazardousProcessAcquired" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="自行监测方案" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.selfMonitorPlan" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="手工监测报告" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.waterSoundGasEtc" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="营业执照" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.license" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="辐射许可证" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.radiationPermit" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="环境管理制度" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.envManageRule" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="非道路移动机械是否备案上牌" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.nonRoadMobileMachineryAcquired" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="行政处罚" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.administrativePenalty" direction="horizontal">
                <van-radio name="0">无</van-radio>
                <van-radio name="1">有</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="信用等级" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.creditLevel" direction="horizontal">
                <van-radio name="1">A</van-radio>
                <van-radio name="2">B</van-radio>
                <van-radio name="3">C</van-radio>
                <van-radio name="4">D</van-radio>
                <van-radio name="5">E</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="200" label="污染源类型" input-align="right">
            <template #input>
              <van-radio-group v-model="companyInfo.pollutionSource" direction="horizontal">
                <van-radio name="1">工业源</van-radio>
                <van-radio name="2">集中源</van-radio>
                <van-radio name="3">移动源</van-radio>
                <van-radio name="4">辐射源</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group>
          <van-field name="radio" label-width="190" label="固体废物" input-align="right">
            <template #input>
              <van-checkbox-group v-model="wasteArr" direction="horizontal">
                <van-checkbox name="1">一般工业固体废物</van-checkbox>
                <van-checkbox name="2">危险废物</van-checkbox>
                <van-checkbox name="3">医疗废物</van-checkbox>
                <van-checkbox name="4">无</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div style="position: fixed;bottom: 0px;width: 100%;">
        <van-button block color="#1B75F6" native-type="submit">完成提交</van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="pickerDict"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="pickerDict"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        ref="manageTypePicker"
        :default-index="manageTypeIndex"
      />
    </van-popup>
    <van-popup v-model="showIndustryPicker" position="bottom" :lazy-render="false">
      <van-search
        v-model="codeName"
        placeholder="请输入行业代码或者名称"
        @search="searchIndustryList"
        shape="round"
        background="#F7F7F7"
      />

      <van-picker
        show-toolbar
        :columns="industryPickerDict"
        @confirm="onIndustryConfirm"
        @cancel="showIndustryPicker = false"
        ref="industrySearch"
        :default-index="industryIndex"
      >
      </van-picker>
    </van-popup>
    <van-popup v-model="showIndustry2Picker" position="bottom" :lazy-render="false">
      <van-search
        v-model="codeName2"
        placeholder="请输入行业代码或者名称"
        @search="searchIndustry2List"
        shape="round"
        background="#F7F7F7"
      />

      <van-picker
        show-toolbar
        :columns="industry2PickerDict"
        @confirm="onIndustry2Confirm"
        @cancel="showIndustry2Picker = false"
        ref="industry2Search"
        :default-index="industry2Index"
      >
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import $ from '@/fly'
import {Toast} from 'vant';

export default {
  name: 'project-modifyCompanyInfo',
  data() {
    return {
      wasteArr:[],
      companyInfo: {
        companyName: '',
        contacts1: '',
        contacts2: '',
        contacts3: '',
        phone1: '',
        phone2: '',
        phone3: '',
        industry: '',
        industry2: '',
        industryName: '',
        industry2Name: '',
        companyAddress: '',
        pollutantManageType: '',
        typeName: '',
        wasteGas: '',
        gasTreatmentFacilities: '',
        wasteWater: '',
        waterTreatmentFacilities: '',
        hazardous: ''
      },
      showPicker: false,
      pickerDict: [],
      manageTypeDict: [],
      showIndustryPicker: false,
      showIndustry2Picker: false,
      industryDict: [],
      industryPickerDict: [],
      codeName: '',
      industry2Dict: [],
      industry2PickerDict: [],
      codeName2: '',
      industryIndex: 0,
      industry2Index: 0,
      manageTypeIndex: 0
    }
  },
  methods: {
    loadManageType() {
      this.showPicker = true;
    },
    onConfirm(value) {
      var typeDict = this.manageTypeDict.filter(function (type) {
        return type.name === value
      })
      var type = typeDict[0];
      this.companyInfo.pollutantManageType = type.code;
      this.companyInfo.typeName = type.name;
      this.showPicker = false;
    },
    onSubmit() {
      this.companyInfo.solidWaste = ''
      for (let i = 0; i < this.wasteArr.length; i++) {
        if(this.companyInfo.solidWaste==''||this.companyInfo.solidWaste==null){
          this.companyInfo.solidWaste = this.wasteArr[i]
        }else{
          this.companyInfo.solidWaste += ','+this.wasteArr[i]
        }
      }
      $.put('company', this.companyInfo).then(res => {
        Toast.success('修改成功！');
        this.$router.back();
      }).catch(err => {
        Toast.fail(err.message);
      })
    },
    onIndustryConfirm(value) {
      var typeDict = this.industryDict.filter(function (type) {
        return type.name === value
      })
      var type = typeDict[0];
      this.companyInfo.industry = type.code;
      this.companyInfo.industryName = type.name;
      this.showIndustryPicker = false;
    },
    onIndustry2Confirm(value) {
      var typeDict = this.industry2Dict.filter(function (type) {
        return type.name === value
      })
      var type = typeDict[0];
      this.companyInfo.industry2 = type.code;
      this.companyInfo.industry2Name = type.name;
      this.showIndustry2Picker = false;
    },
    searchIndustryList() {
      $.get('dict/getCodeNameDictByTypeMobile', {
        type: 'industry_code',
        codeName: this.codeName
      }).then(res => {
        this.industryPickerDict = [];
        this.industryDict = res;
        this.industryDict.forEach(item => {
          this.industryPickerDict.push(item.name);
        })
        this.$refs.industrySearch.setColumnValues(0, this.industryPickerDict);
      })
    },
    searchIndustry2List() {
      $.get('dict/getCodeNameDictByTypeMobile', {
        type: 'industry_code',
        codeName: this.codeName2
      }).then(res => {
        this.industry2PickerDict = [];
        this.industry2Dict = res;
        this.industry2Dict.forEach(item => {
          this.industry2PickerDict.push(item.name);
        })
        this.$refs.industry2Search.setColumnValues(0, this.industry2PickerDict);
      })
    }
  },
  mounted() {
    var that = this;
    $.get('company/getById/' + localStorage.getItem('companyId')).then(res => {
      this.companyInfo = res;
      if(this.companyInfo.solidWaste!=null && this.companyInfo.solidWaste!=''){
        this.wasteArr = this.companyInfo.solidWaste.split(',')
      }


      // 加载排污许可证管理类别下拉字典
      $.get('dict/getDictByType/' + 'pollutantManageType').then(res => {
        this.manageTypeDict = res;
        this.manageTypeDict.forEach(item => {
          this.pickerDict.push(item.name);
        })
        var index = this.pickerDict.findIndex(function (data) {
          return data === that.companyInfo.typeName;
        })
        this.manageTypeIndex = index;
      })

      // 加载行业下拉字典
      $.get('dict/getCodeNameByTypeMobile/HYML/HYXL').then(res => {
        this.industryDict = res;
        this.industryDict.forEach(item => {
          this.industryPickerDict.push(item.name);
        })
        var index = this.industryPickerDict.findIndex(function (data) {
          return data === that.companyInfo.industry + ' ' + that.companyInfo.industryName;
        })
        this.industryIndex = index;
      })

      // 加载第二行业下拉字典
      $.get('dict/getCodeNameByTypeMobile/HYML/HYXL').then(res => {
        this.industry2Dict = res;
        this.industry2Dict.forEach(item => {
          this.industry2PickerDict.push(item.name);
        })
        var index = this.industry2PickerDict.findIndex(function (data) {
          return data === that.companyInfo.industry2 + ' ' + that.companyInfo.industry2Name;
        })
        this.industry2Index = index;
      })
    })
  }
}
</script>

<style lang="less" scoped>
.topDiv {
  margin-top: 20px;
}

.lableTxt {
  height: 80px;
  line-height: 80px;
  font-size: 28px;
  width: 28%;
}

.starTxt {
  height: 80px;
  line-height: 80px;
  font-size: 28px;
}

.starTxt span {
  color: #FF6969;
  font-size: 30px;
  margin-right: 3px;
}

.typeDiv {
  padding: 20px 30px;
  font-size: 28px;
}

.typeRow {
  padding-left: 20px;
  border-left: 6px solid #50C9FF;
}

.typeRow .van-col:nth-child(2) {
  font-size: 0.38rem;
  font-weight: 400;
}

.typeItem {
  box-shadow: #f2f3f5 0px 0px 20px 1px;
}

.type-search {
  background-color: #EBEEF5;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 2vw 4vw;
  border-radius: 50px;
  padding: 0 0 0 4vw;
}

.type-search button {
  border-radius: 0 50px 50px 0;
}

.search-icon {
  margin-left: 5px;
  font-size: 50px;
}

.searchInput {
  margin: 0 1.5vw;
  background-color: #F7F8FA;
  border: 0px;
  font-size: 14px;
  flex: 1;
  background: none;
  padding: 15px;
}

.clear-icon {
  color: #999;
  font-size: 40px;
  margin-right: 15px;
}

.van-cell {
  font-size: 0.37rem;
}

.van-radio {
  color: #666666;
}

</style>
